export default function Headline({ text, subText, extraClass, subClass }) {
  return (
    <h3
      className={`font-bold text-2xl 
                  md:text-4xl text-[#000] 
                  ${extraClass}
                `}
    >
      {text}
      <br />
      <p className={subClass}> {subText}</p>
    </h3>
  );
}
